/*
 * @Description:
 * @Author: ma.cq
 * @Date: 2019-09-03 09:08:15
 * @LastEditors: ma.cq
 * @LastEditTime: 2020-04-09 10:27:09
 */
// 校验emoji正则
export const checkEmoji = /\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g

// 校验手机号正则
export const checkPhone = /^1[3-9][0-9]{9}$/

// 校验网址正则
export const checkUrl = /^(https|http):\/\/.+\..+\..+$/

// 校验密码格式正则
export const checkPassword = /^[a-zA-Z0-9`~!@#$%^*()[\]{\\}:;',./<>?|\-_+=]{8,20}$/g

// 校验密码复杂度
export const checkPasswordEasy = password => {
  // 不可使用過於簡單的密碼，暫定為連續的自然數、連續的英文字母、相同的數位、相同的符號、相同的英文字母
  const passwordReg2 = /^(.)\1*$/g // 全部相同則爲簡單
  // 匹配密碼是否過於簡單
  if (passwordReg2.test(password)) {
    return false
  }
  let lineFlag = false
  const re = /^[0-9]{8,10}$/g
  const re1 = /^[a-z]{1,20}$/g
  const re2 = /^[A-Z]{1,20}$/g
  // 如果是全数字或全字母，则利用ASCII码 判断是否是连续的数字或英文字母
  if (re.test(password) || re1.test(password) || re2.test(password)) {
    for (let i = 0; i < password.length - 1; i++) {
      const t1 = password.charCodeAt(i)
      const t2 = password.charCodeAt(i + 1)
      if (t2 === t1 + 1) {
        lineFlag = true
        continue
      } else {
        lineFlag = false
        break
      }
    }
    if (lineFlag) {
      return false
    }
  }
  return true
}

// 校验邮箱正则
export const checkEmail = /\w[-\w.+]*@([A-Za-z0-9]+\.)[A-Za-z]{2,14}/

// 校验营业执照正则
export const checkLicence = /(^(?:(?![IOZSV])[\dA-Z]){2}\d{6}(?:(?![IOZSV])[\dA-Z]){10}$)|(^\d{15}$)/

// 校验QQ正则
export const checkQQ = /[1-9][0-9]{4,}/

// 仅汉字及英文正则
export const checkEnAndCn = /^[\u4e00-\u9fa5_a-zA-Z\s]+$/

// 纯数字阻止输入用方法
export const normalizeNumber = (val, length) => {
  return val.replace(/[^\d]/g, '').slice(0, length)
}

export const checkCode = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?])(?=.*[^\s]).{8,}$/
export const checkCodeold = /^[a-zA-Z0-9]{6,20}$/
